import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, MapPin } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';

const V2Clients = () => {
  useSEO({
    title: 'Clients | Videra in live operational use',
    description: 'Keystone / Videra clients. Videra is in live PFI Hard Services use with VINCI Facilities supporting hospital estates in the North and South of England.',
    path: '/clients',
  });

  return (
    <div data-testid="v2-clients">
      <ProductHero
        eyebrow="Clients"
        title="In live operational use with a Tier-1 Facilities partner."
        body={(
          <>
            <p>Videra has progressed beyond concept and prototype. Videra technology is in live use within PFI Hard Services environments involving a Tier-1 facilities contractor supporting hospital estates in the North and South of England.</p>
            <p>Additional prospective users are exploring Videra Healthcare, Videra Vanguard, SafeTrace and the Firestopping Business Dashboard through 14-day fully unlocked Specialist trials, and Videra PM through a 7-day fully unlocked trial.</p>
          </>
        )}
        testid="clients-hero"
      />

      <section className="py-16 md:py-24 bg-slate-50 border-y border-slate-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">Live customer</p>
          <div className="bg-white border border-slate-200 rounded-2xl p-8 md:p-10" data-testid="client-vinci">
            <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-8 md:gap-10 items-center">
              <div className="bg-white rounded-xl border border-slate-100 p-6 flex items-center justify-center">
                <img src="/images/clients/vinci-facilities.png" alt="VINCI Facilities logo" className="max-h-24 w-auto" />
              </div>
              <div>
                <h2 className="text-2xl md:text-3xl font-medium tracking-tight text-slate-900 leading-tight">VINCI Facilities</h2>
                <p className="mt-3 text-slate-600 leading-relaxed">
                  VINCI Facilities is using Videra technology within live PFI Hard Services environments supporting hospital estates in the North and South of England, connecting lifecycle requirements, projects, approvals, delivery, evidence and progressive handback readiness.
                </p>
                <div className="mt-5 flex flex-wrap gap-2">
                  <span className="inline-flex items-center gap-1.5 text-xs bg-emerald-50 text-emerald-700 rounded-full px-3 py-1"><ShieldCheck className="w-3 h-3" /> Live PFI Hard Services use</span>
                  <span className="inline-flex items-center gap-1.5 text-xs bg-slate-100 text-slate-700 rounded-full px-3 py-1"><MapPin className="w-3 h-3" /> UK healthcare estates</span>
                </div>
                <div className="mt-6 flex flex-col sm:flex-row gap-3">
                  <Link to="/videra/hard-services" className="inline-flex items-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-testid="clients-explore-hs">
                    Explore Videra Hard Services <ArrowRight className="w-4 h-4" />
                  </Link>
                  <Link to="/contact" className="inline-flex items-center justify-center gap-1 border border-slate-300 text-slate-900 px-6 py-3 rounded-md text-sm font-medium hover:border-slate-900 transition-colors">
                    Talk to Keystone
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <p className="mt-6 text-xs text-slate-500 leading-relaxed max-w-3xl">
            Reference used with permission. Not a customer endorsement of any specific commercial claim. For all other prospective users, Videra is available to explore through a 14-day fully unlocked Specialist trial at demo.videra.app and a 7-day fully unlocked trial at pm.videra.app.
          </p>
        </div>
      </section>
    </div>
  );
};

export default V2Clients;
